import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICON } from '@core/util/icon';

@Component({
	selector: 'app-business-user-select',
	templateUrl: './business-user-select.component.html',
	standalone: false,
})
export class BusinessUserSelectComponent {
	@Input() selectedUserId: string;
	@Input() disabled = false;
	@Output() onSelected: EventEmitter<void> = new EventEmitter<void>();

	public ICON = ICON;

	selected() {
		if (this.disabled) {
			return;
		}

		this.onSelected.emit();
	}
}
